import React, { useEffect, useRef } from 'react'
import PageHeading from '../../../components/PageHeading';
import HighchartsReact from 'highcharts-react-official';
import Highcharts from 'highcharts';
import { all } from 'axios';
import { useState } from 'react';

export default function Expenses({ expensesData, setExpensesType }) {
    const chartRef = useRef(null);
    useEffect(() => {
        if (chartRef.current) {
            const chart = chartRef.current.chart;

            // Calculate the exact center of the plot area
            const centerX = (chart.plotWidth / 2.7) + chart.plotLeft;
            const centerY = (chart.plotHeight / 2.5) + chart.plotTop;
            const center1X = (chart.plotWidth / 2.7) + chart.plotLeft;
            const center1Y = (chart.plotHeight / 2) + chart.plotTop;

            // Add a custom label in the center
            chart.renderer
                .label('Total Expenses', centerX, centerY)
                .attr({
                    zIndex: 99,
                })
                .css({
                    color: '#737791',
                    fontSize: '12px',
                    fontWeight: "400"
                })
                .add();

            chart.renderer
                .label('₹ 0', center1X, center1Y)
                .attr({
                    zIndex: 99,
                })
                .css({
                    color: '#000',
                    fontSize: '18px',
                    fontWeight: "600",
                    justifyContent: "center",
                   textAlign: "center"
                })
                .add();
        }
    }, []);
    let handleChange = (e) => {
        let value = e.target.value
        setExpensesType(parseInt(value))
    }
    const options = {
        chart: {
            type: 'pie',
            margin: [0, 0, 0, 0],
            spacingTop: 0,
            spacingBottom: 0,
            spacingLeft: 0,
            spacingRight: 0,
            height: '250px'
        },
        title: {
            text: '',
        },
         credits: {
    enabled: false  
  },
        plotOptions: {
            pie: {
                innerSize: '70%',
                size: "100%",
                dataLabels: {
                    enabled: false,
                },
            },
            borderRadius: 600,
        },
        series: [
            {
                name: 'Categories',
                data: [
                    { name: 'Red', y: 300, color: '#4187F5' },
                    { name: 'Green', y: 50, color: '#F59E0C' },
                    { name: 'Yellow', y: 100, color: '#1F9E98' },
                    { name: 'whute', y: 100, color: '#EEA47F' },
                ],
            },
        ],

    };
const [weak, setWeak] = useState({ type: "" });
const [month, setMonth] = useState({ type: "" });
const [year, setYear] = useState({ type: "" });
    return (
        <div className='container-fluid landformconatiner  p-4'>
            <div className='d-flex flex-row justify-content-between'>
                <PageHeading pagename="Expenses" />
              <select
  style={{ height: "45px",
     width: "100px" ,
    border: "2px solid #00AFF0",
    color: "#00AFF0",
 borderRadius: "10px",
 padding:'10px',
 outline:'none'

   }}
  onChange={handleChange}
>
  <option value={1}>Project</option>
  <option value={2}>Office</option>
</select>


            </div>
        <div className="d-flex align-items-center pt-3 gap-3">

  <select
    className="form-input-box"
    style={{
      height: "35px",
      width: "90px",
      backgroundColor: "white",
      border: "1px solid #EDEDED",
      borderRadius: "5px",
      padding: "0 8px"
      ,
 outline:'none'
    }}
    value={weak.type}
    onChange={(e) => setWeak({ ...weak, type: e.target.value })}
  >
    <option value="">Week</option>
    <option value="1">1</option>
    <option value="2">2</option>
  </select>

  <select
    className="form-input-box"
    style={{
      height: "35px",
      width: "90px",
      backgroundColor: "white",
      border: "1px solid #EDEDED",
      borderRadius: "5px",
      padding: "0 8px",
 outline:'none'
    }}
    value={month.type}
    onChange={(e) => setMonth({ ...month, type: e.target.value })}
  >
    <option value="">Month</option>
    <option value="jan">Jan</option>
    <option value="feb">Feb</option>
  </select>

  <select
    className="form-input-box"
    style={{
      height: "35px",
      width: "90px",
      backgroundColor: "white",
      border: "1px solid #EDEDED",
      borderRadius: "5px",
      padding: "0 8px",
 outline:'none'
    }}
    value={year.type}
    onChange={(e) => setYear({ ...year, type: e.target.value })}
  >
    <option value="">Year</option>
    <option value="2024">2024</option>
    <option value="2025">2025</option>
  </select>

</div>

            <div className='row pt-3 mt-2' style={{ height: "295px" }}>
                <HighchartsReact highcharts={Highcharts} options={options} ref={chartRef} />
            </div>

            <div className='d-flex flex-column gap-3 pt-3 mt-2'>
                {
                    expensesData && expensesData.map((val, ind) => {
                        return (
                            <div className='d-flex flex-row justify-content-between pb-2 rowBox' >
                                <div className='d-flex flex-row gap-2'>
                                    <div className='projecticon' style={{ backgroundColor: "#3B82F6" }}>
                                        <svg width="16" height="16" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M2 0C0.895432 0 0 0.895447 0 2V16C0 17.1046 0.895432 18 2 18H16C17.1046 18 18 17.1046 18 16V2C18 0.895447 17.1046 0 16 0H2ZM5 10C5 9.44769 4.55228 9 4 9C3.44772 9 3 9.44769 3 10V14C3 14.5523 3.44772 15 4 15C4.55228 15 5 14.5523 5 14V10ZM9 6C9.55228 6 10 6.44769 10 7V14C10 14.5523 9.55228 15 9 15C8.44772 15 8 14.5523 8 14V7C8 6.44769 8.44772 6 9 6ZM15 4C15 3.44769 14.5523 3 14 3C13.4477 3 13 3.44769 13 4V14C13 14.5523 13.4477 15 14 15C14.5523 15 15 14.5523 15 14V4Z" fill={"rgba(255, 255, 255, 1)"} />
                                        </svg>

                                    </div>
                                    <span className='d-flex flex-column '>
                                        <label className='heading-project fw-semibold'>{val.expenseName}</label>
                                        {/* <label className='sub-heading-project' >Online Sell</label> */}
                                    </span>
                                </div>
                                <div className='d-flex flex-row'>
                                    <PageHeading pagename="35%" />
                                </div>
                            </div>
                        )
                    })
                }

                <div className='d-flex flex-row justify-content-between  pb-2 rowBox' >
                    <div className='d-flex flex-row gap-2'>
                        <div className='projecticon' style={{ backgroundColor: "#F59E0B" }}>
                            <svg width="16" height="16" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M2 0C0.895432 0 0 0.895447 0 2V16C0 17.1046 0.895432 18 2 18H16C17.1046 18 18 17.1046 18 16V2C18 0.895447 17.1046 0 16 0H2ZM5 10C5 9.44769 4.55228 9 4 9C3.44772 9 3 9.44769 3 10V14C3 14.5523 3.44772 15 4 15C4.55228 15 5 14.5523 5 14V10ZM9 6C9.55228 6 10 6.44769 10 7V14C10 14.5523 9.55228 15 9 15C8.44772 15 8 14.5523 8 14V7C8 6.44769 8.44772 6 9 6ZM15 4C15 3.44769 14.5523 3 14 3C13.4477 3 13 3.44769 13 4V14C13 14.5523 13.4477 15 14 15C14.5523 15 15 14.5523 15 14V4Z" fill={"rgba(255, 255, 255, 1)"} />
                            </svg>

                        </div>
                        <span className='d-flex flex-column '>
                            <label className='heading-project fw-semibold'>Available Area</label>
                            <label className='sub-heading-project' >Offline Sell</label>
                        </span>
                    </div>
                    <div className='d-flex flex-row'>
                        <PageHeading pagename="0%" />
                    </div>
                </div>
                <div className='d-flex flex-row justify-content-between  pb-2 rowBox' >
                    <div className='d-flex flex-row gap-2'>
                        <div className='projecticon' style={{ backgroundColor: "#14B8A6" }}>
                            <svg width="16" height="16" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M2 0C0.895432 0 0 0.895447 0 2V16C0 17.1046 0.895432 18 2 18H16C17.1046 18 18 17.1046 18 16V2C18 0.895447 17.1046 0 16 0H2ZM5 10C5 9.44769 4.55228 9 4 9C3.44772 9 3 9.44769 3 10V14C3 14.5523 3.44772 15 4 15C4.55228 15 5 14.5523 5 14V10ZM9 6C9.55228 6 10 6.44769 10 7V14C10 14.5523 9.55228 15 9 15C8.44772 15 8 14.5523 8 14V7C8 6.44769 8.44772 6 9 6ZM15 4C15 3.44769 14.5523 3 14 3C13.4477 3 13 3.44769 13 4V14C13 14.5523 13.4477 15 14 15C14.5523 15 15 14.5523 15 14V4Z" fill={"rgba(255, 255, 255, 1)"} />
                            </svg>

                        </div>
                        <span className='d-flex flex-column '>
                            <label className='heading-project fw-semibold'>Sale Area</label>
                            <label className='sub-heading-project'>Agent Sell</label>
                        </span>
                    </div>
                    <div className='d-flex flex-row'>
                        <PageHeading pagename="0%" />
                    </div>
                </div>
                <div className='d-flex flex-row justify-content-between pb-2 rowBox' >
                    <div className='d-flex flex-row gap-2'>
                        <div className='projecticon' style={{ backgroundColor: "#F59E0B" }}>
                            <svg width="16" height="16" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M2 0C0.895432 0 0 0.895447 0 2V16C0 17.1046 0.895432 18 2 18H16C17.1046 18 18 17.1046 18 16V2C18 0.895447 17.1046 0 16 0H2ZM5 10C5 9.44769 4.55228 9 4 9C3.44772 9 3 9.44769 3 10V14C3 14.5523 3.44772 15 4 15C4.55228 15 5 14.5523 5 14V10ZM9 6C9.55228 6 10 6.44769 10 7V14C10 14.5523 9.55228 15 9 15C8.44772 15 8 14.5523 8 14V7C8 6.44769 8.44772 6 9 6ZM15 4C15 3.44769 14.5523 3 14 3C13.4477 3 13 3.44769 13 4V14C13 14.5523 13.4477 15 14 15C14.5523 15 15 14.5523 15 14V4Z" fill={"rgba(255, 255, 255, 1)"} />
                            </svg>

                        </div>
                        <span className='d-flex flex-column '>
                            <label className='heading-project fw-semibold'>Pending Area</label>
                            <label className='sub-heading-project'>0x0 SF</label>
                        </span>
                    </div>
                    <div className='d-flex flex-row'>
                        <PageHeading pagename="0%" />
                    </div>
                </div>
            </div>
        </div>
    )
}
